import { useEffect, useState } from "react";
import { getCounterUserBalance } from "../helpers/top-navbar-helper";
import { useSelector } from "react-redux";

export default function CounterUserBalanceChip({ userId }) {
    const { isNewBookingActionOccured } = useSelector(
        (state) => state.counterPanelTripSearch
    );
    const [balance, setBalance] = useState({
        current_balance: 0,
        currency: "BDT",
    });
    const [isLoading, setIsLoading] = useState(false);

    const getAndSetBalance = async () => {
        setIsLoading(true);
        const balance = await getCounterUserBalance(userId);
        setBalance(balance);

        setIsLoading(false);
    };

    useEffect(() => {
        if (userId) {
            getAndSetBalance();
        }
    }, [userId]);

    useEffect(() => {
        if (isNewBookingActionOccured && userId) {
            getAndSetBalance();
        }
    }, [isNewBookingActionOccured]);

    return isLoading ? (
        <p className="text-xs font-medium animate-pulse px-1.5 bg-white border border-white rounded-full">
            ৳
        </p>
    ) : (
        <div className="flex gap-x-1 items-center text-xs font-medium text-red-600 px-1 py-px rounded-md bg-white">
            <p>{Math.round(balance?.current_balance || 0)}</p>
            <p>{balance?.currency || "BDT"}</p>
        </div>
    );
}
